import { PublicClientApplication } from "@azure/msal-browser";
import { PspContextType } from "./config/types";
import { MsalProvider } from "@azure/msal-react";
import { PspContext } from "./config/contexts";
import { Slide, ToastContainer } from "react-toastify";
import { MfaSetup } from "./mfa/mfaSetup";
import CookieConsentDialog from "./cookies/cookieConsentDialog";
import { Outlet } from "react-router-dom";

type AppProvidersWrapperProps = {
  pspContext: PspContextType;
  msalInstance: PublicClientApplication;
  cookieConsentDialogOpen: boolean;
};

export function AppProvidersWrapper({
  pspContext,
  msalInstance,
  cookieConsentDialogOpen,
}: AppProvidersWrapperProps) {
  return (
    <MsalProvider instance={msalInstance}>
      <PspContext.Provider value={pspContext}>
        <div id="portal-root" />

        <ToastContainer
          style={{ zIndex: 2147483647 }}
          position="bottom-right"
          autoClose={5000}
          theme="light"
          transition={Slide}
        />

        <MfaSetup />
        <CookieConsentDialog isOpen={cookieConsentDialogOpen} />

        <Outlet />
      </PspContext.Provider>
    </MsalProvider>
  );
}
